import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import styled from "styled-components";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

const HeaderTable = styled.div`
    text-align:center;
    color:#223a77;
    font-size:24px;
`

const IconHeader = styled(RequestQuoteIcon)`
    margin-right:10px;
    width: 30px !important;
    height: 30px !important;
`

const HeaderTitulo = styled.span`
    vertical-align:text-bottom;
    margin-bottom:10px;
`
const MessageNota = styled.p`
    font-size:14px;
    color:#000000;
    margin-top:10px;
`


const TabelaNotasFiscais = (props) => {

    const [notas, setNotas] = useState([]);
    const [tipoProduto, setTipoProduto] = useState("TERRESTRE")

    useEffect(() => {
        setNotas(props.fatura.notas);
        setTipoProduto(props.tipoProduto);
        console.log(tipoProduto)
    }, [notas, props, tipoProduto]);

    const header = (
        <HeaderTable>
            <p><IconHeader/><HeaderTitulo>NOTA FISCAL</HeaderTitulo></p>
            <MessageNota>Nota: Obrigatória a emissão e envio de Nota(s) Fiscal(is) da(s) COMISSÃO(ÕE S) e do(s) INCENTIVO(S) conforme valores abaixo indicados:</MessageNota>
        </HeaderTable>
    );

    const enderecoBodyTemplate  = (rowData) => {
        let endereco = 
        <div>
            <p>{rowData.nome}</p>
            <p>{rowData.endereco}</p>
            <p>{rowData.cidade} - {rowData.uf}</p>
            <p>CNPJ: {rowData.cnpj} - IE: {rowData.ie}</p>
        </div>
        return endereco;
    }

    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const formatNumber = new Intl.NumberFormat('pt-BR', options);

    const valorBodyTemplate = (rowData) => {   
        let value = rowData.valor;
        var formattedMoney = formatNumber.format(value);
        return formattedMoney;
    }
    return (
        <>
        { tipoProduto !== 'TERRESTRE' ? 
            <DataTable header={header} size="small" stripedRows value={notas} responsiveLayout="scroll" rowGroupMode="subheader" 
                sortMode="single" sortOrder={1} scrollable scrollHeight="500px" scrollDirection="both" >
                 
                <Column bodyStyle={{ width: '10%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '10%', fontSize:"12px" }} field="cia" header="CIA"></Column>
                <Column bodyStyle={{ width: '56%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '56%', fontSize:"12px" }} field={enderecoBodyTemplate} header="DADOS FORNECEDOR"></Column>
                <Column bodyStyle={{ width: '10%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '10%', fontSize:"12px" }} field="valor" body={valorBodyTemplate} header="COMISSÃO"></Column>
                <Column bodyStyle={{ width: '12%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '12%', fontSize:"12px" }} field="valor" body={valorBodyTemplate} header="VALOR NF"></Column>
                <Column bodyStyle={{ width: '12%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '12%', fontSize:"12px" }} field="issrf" header="VALOR ISSRF"></Column>
            </DataTable>
            : 
            <DataTable header={header} size="small" stripedRows value={notas} responsiveLayout="scroll" rowGroupMode="subheader" 
                sortMode="single" sortOrder={1} scrollable scrollHeight="500px" scrollDirection="both" >
                 
                <Column bodyStyle={{ width: '66%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '66%', fontSize:"12px" }} field={enderecoBodyTemplate} header="DADOS FORNECEDOR"></Column>
                <Column bodyStyle={{ width: '10%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '10%', fontSize:"12px" }} field="valor" body={valorBodyTemplate} header="COMISSÃO"></Column>
                <Column bodyStyle={{ width: '12%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '12%', fontSize:"12px" }} field="valor" body={valorBodyTemplate} header="VALOR NF"></Column>
                <Column bodyStyle={{ width: '12%' }} headerStyle={{ backgroundColor: '#223a77', color: 'white', width: '12%', fontSize:"12px" }} field="issrf" header="VALOR ISSRF"></Column>
            </DataTable> }
        </>
    );
}

export default TabelaNotasFiscais;
